if (!customElements.get('product-stack')) {
  class ProductStack extends HTMLElement {
    constructor() {
      super();
    }

    async addStackToCart(data) {
      const minicart = document.querySelector('mini-cart');
      const cart_content = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest'
        },
        body: JSON.stringify( data )
      })
      .then(response => response.json())
      .catch(error => {
        console.error(error);
      });

      minicart.updateCartHtml(cart_content)
      minicart.open();
    }

    connectedCallback() {
      const stack_button = this.querySelector('[data-stack-button]');

      if (stack_button) {
        stack_button.addEventListener('click', () => {
          const items = [];
          const quickbuy_elements = this.querySelectorAll('quick-buy');

          quickbuy_elements.forEach(el => {
            const variant_id = el.getAttribute('data-variant-id');
            const data = {
              id: variant_id,
              quantity: 1
            }

            items.push(data);
          });

          const data = {
            items,
            sections: ['minicart']
          };

          this.addStackToCart(data)
        });
      }
    }
  }

  customElements.define('product-stack', ProductStack);
}
